import { UserProfileType } from '../types/profile';

export const REPORT_ALLOWED_PROFILES: UserProfileType[] = [
  'Administrator',
  'Zone Spoc'
];
